import { NgModule } from '@angular/core';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';

@NgModule({
  providers: [InAppBrowser],
})
export class InAppBrowserModule {}
